export interface DTO {
  [key: string]: string | number | boolean | any;
}
